import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { blockUserAuth0, unBlockUserAuth0 } from '../../../api/auth0Api';
import toast from 'react-hot-toast';

function useBlockUnblockUser() {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const [blockPopover, setBlockPopover] = useState(null);
  const [unBlockPopover, setUnBlockPopover] = useState(null);
  const [auth0UserId, setAuth0UserId] = useState('');

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const { mutate: handleBlockConfirm } = useMutation({
    mutationFn: async () => {
      handleClosePopover('block');
      toast.loading('Desactivando usuario...', {
        id: 'block-user',
      });
      let token = await getAccessTokenSilently();
      await blockUserAuth0(token, auth0UserId);
    },
    onSuccess: async () => {
      await sleep(1000);
      queryClient.invalidateQueries(['all-users']);
    },
    onError: (error) => {
      toast.error('Se ha producido un error al activar el usuario.');
      console.log('error', error);
    },
    onSettled: () => {
      toast.dismiss('block-user');
    },
  });

  const { mutate: handleUnBlockConfirm } = useMutation({
    mutationFn: async () => {
      handleClosePopover('unblock');

      toast.loading('Activando usuario...', {
        id: 'unblock-user',
      });
      let token = await getAccessTokenSilently();
      await unBlockUserAuth0(token, auth0UserId);
    },
    onError: (error) => {
      toast.error('Se ha producido un error al desactivar el usuario.');
      console.log('error', error);
    },
    onSuccess: async () => {
      await sleep(1000);
      queryClient.invalidateQueries(['all-users']);
    },
    onSettled: () => {
      toast.dismiss('unblock-user');
    },
  });

  const popover = (type) => {
    switch (type) {
      case 'block':
        return blockPopover;
      case 'unblock':
        return unBlockPopover;
      default:
        return null;
    }
  };

  const handleClosePopover = (type) => {
    switch (type) {
      case 'block':
        setBlockPopover(null);
        break;
      case 'unblock':
        setUnBlockPopover(null);
        break;
      default:
        break;
    }
  };

  const handleClickPopover = (type, event) => {
    console.log(event.currentTarget.dataset.userId);
    setAuth0UserId(event.currentTarget.dataset.userId);
    switch (type) {
      case 'block':
        setBlockPopover(event.currentTarget);
        break;
      case 'unblock':
        setUnBlockPopover(event.currentTarget);
        break;
      default:
        break;
    }
  };

  const handleConfirmPopover = (type) => {
    switch (type) {
      case 'block':
        handleBlockConfirm();
        break;
      case 'unblock':
        handleUnBlockConfirm();
        break;
      default:
        break;
    }
  };

  return { popover, handleClosePopover, handleClickPopover, handleConfirmPopover };
}

export default useBlockUnblockUser;
